import { DomHelper } from '../modules/DomHelper';
import { ScrollAnimation } from '../modules/ScrollAnimation';

/**
 * MicroPage — マイクロインタラクション デモページ
 * data-page="micro" のときに初期化される
 *
 * 担当:
 *   - スクロールアニメーション リセットボタン
 *     （アニメーション本体は ScrollAnimation.initAll() が共通処理として担当）
 *   - Range スライダーの値表示更新
 */
export class MicroPage {
  init(): void {
    this.initResetButton();
    this.initRangeSliders();
  }

  // ----------------------------------------------------------
  // スクロールアニメーション リセットボタン
  // ----------------------------------------------------------
  private initResetButton(): void {
    const resetBtn = DomHelper.qs<HTMLButtonElement>('.js-anim-reset');
    resetBtn?.addEventListener('click', () => {
      ScrollAnimation.reset('.js-scroll-animation[data-anim]');
    });
  }

  // ----------------------------------------------------------
  // Range スライダー: 値をリアルタイム表示
  // ----------------------------------------------------------
  private initRangeSliders(): void {
    DomHelper.qsa<HTMLInputElement>('.c-custom-range__input').forEach((input) => {
      const valueEl = input
        .closest('.c-custom-range')
        ?.querySelector<HTMLElement>('.c-custom-range__value');
      if (!valueEl) return;

      // 初期値を反映
      valueEl.textContent = input.value;

      input.addEventListener('input', () => {
        valueEl.textContent = input.value;
      });
    });
  }
}
